export const SET_PROJECTS_STATUSES = 'SET_PROJECTS_STATUSES'
export const SET_FACETED_DATA = 'SET_FACETED_DATA'
export const SET_FILTERS = 'SET_FILTERS'
export const SET_DATES_RANGE = 'SET_DATES_RANGE'
export const SET_FACETS_MODE = 'SET_FACETS_MODE'
export const SET_SORT_BY = 'SET_SORT_BY'
export const SET_IS_LOADING = 'SET_IS_LOADING'
export const SET_QUERY_VALUE = 'SET_QUERY_VALUE'
